import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
// import { API_URL } from "../../config/config";

const API_URL = process.env.REACT_APP_API_URL;

// Helper to get token from Redux or storage
const getAuthToken = (getState) =>
  (getState && getState().auth && getState().auth.token) ||
  sessionStorage.getItem("access_token") ||
  localStorage.getItem("access_token");

export const fetchLatestSpO2 = createAsyncThunk(
  "spo2/fetchLatest",
  async (patientId, { rejectWithValue, getState }) => {
    try {
      const token = getAuthToken(getState);
      const response = await axios.get(
        `${API_URL}/vitals/patient/${patientId}/spo2/latest`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue("Failed to fetch SpO2 data");
    }
  }
);

const spo2Slice = createSlice({
  name: "spo2",
  initialState: { data: null, loading: false, error: null },
  reducers: {
    clearSpO2(state) {
      state.data = null;
      state.loading = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchLatestSpO2.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchLatestSpO2.fulfilled, (state, action) => {
        state.data = action.payload;
        state.loading = false;
      })
      .addCase(fetchLatestSpO2.rejected, (state, action) => {
        state.error = action.payload;
        state.loading = false;
      });
  },
});

export const { clearSpO2 } = spo2Slice.actions;

export const selectSpO2 = (state) => state.spo2;

export default spo2Slice.reducer;


// import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
// import axios from "axios";
// // import { API_URL } from "../../config/config";

// const API_URL = process.env.REACT_APP_API_URL;


// export const fetchLatestSpO2 = createAsyncThunk(
//   "spo2/fetchLatest",
//   async (patientId, thunkAPI) => {
//     try {
//       const response = await axios.get(
//         `${API_URL}/vitals/patient/${patientId}/spo2/latest`
//       );
//       return response.data;
//     } catch (error) {
//       return thunkAPI.rejectWithValue("Failed to fetch SpO2 data");
//     }
//   }
// );

// const spo2Slice = createSlice({
//   name: "spo2",
//   initialState: { data: null, loading: false, error: null },
//   reducers: {
//     clearSpO2(state) {
//       state.data = null;
//       state.loading = false;
//       state.error = null;
//     },
//   },
//   extraReducers: (builder) => {
//     builder
//       .addCase(fetchLatestSpO2.pending, (state) => {
//         state.loading = true;
//         state.error = null;
//       })
//       .addCase(fetchLatestSpO2.fulfilled, (state, action) => {
//         state.data = action.payload;
//         state.loading = false;
//       })
//       .addCase(fetchLatestSpO2.rejected, (state, action) => {
//         state.error = action.payload;
//         state.loading = false;
//       });
//   },
// });

// export const { clearSpO2 } = spo2Slice.actions;

// export const selectSpO2 = (state) => state.spo2;

// export default spo2Slice.reducer;
